/**
 * FF-3636: which top-level routes the router wraps in ProtectedRoute. Extracted so it is testable,
 * and because it matched '/admin/' while the only top-level admin route is '/admin', so the guard
 * wrapped nothing.
 */
export const PUBLIC_PATHS = [
  '/auth/reset-password',
  '/auth/forgot-password',
  '/auth/login',
  '/auth/complete-invite',
  '/auth/error',
  '/login',
]

export const isPublicPath = (path?: string): boolean =>
  PUBLIC_PATHS.some((publicPath) => path === publicPath || path?.startsWith(publicPath + '/'))

/** The admin tree is guarded; children inherit the guard through the outlet in pages/admin. */
export const routeRequiresAuth = (path?: string): boolean =>
  !isPublicPath(path) && (path === '/admin' || !!path?.startsWith('/admin/'))
